exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eula-text p[data-v-27b7efd0]:first-child{margin-top:0}.eula-text p[data-v-27b7efd0]:last-child{margin-bottom:0}.inner-list[data-v-27b7efd0]{list-style-type:disc}li[data-v-27b7efd0]{padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27b7efd0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/fragments/eula_text.vue
// module id = eWtg
// module chunks = 0